import React, {
  cloneElement,
  createElement,
  createRef,
  forwardRef,
  useCallback,
  useEffect,
  useState,
} from 'react';
import ReactDOM, { render } from 'react-dom';
import { useDispatch } from 'react-redux';
import {
  addOverlay,
  removeOverlay,
  updateOverlay,
} from '../Actions/Overlay.action';
import Icon from './IconBase/Icon';
// import colors from 'Exports/colors.scss';

export default forwardRef(
  (
    {
      id,
      duration = '0.2s',
      from = 'right',
      className,
      open,
      onClosed,
      showCloseButton = true,
      children,
      title,
      headerRef,
      footer,
      disableClosing = false,
      closeButton = null,
      languageSwitcher = null,
      messageBar = null,
    },
    ref
  ) => {
    const [slideIn, setSlideIn] = useState();
    const [timeoutId, setTimeoutId] = useState();
    const dispatch = useDispatch();

    if (!id || id == '') {
      throw new Error(
        'A unique side-menu "id" must be passed to side menu component'
      );
    }

    const close = useCallback(() => {
      if (!disableClosing) {
        // Just sets "slideIn" to false, which triggers the animation to close it
        setSlideIn(false);
        return true;
      }

      // False disables overlay click
      return false;
    }, [disableClosing]);

    useEffect(() => {
      dispatch(updateOverlay(id, close));
    }, [dispatch, close, id]);

    useEffect(() => {
      if (!slideIn) {
        // If not slide in, slide out :^)
        if (timeoutId) {
          // Clear previous timeout to avoid animation delay bug
          clearTimeout(timeoutId);
        }

        var newTimeoutId = setTimeout(() => {
          setTimeoutId(undefined);
          onClosed && onClosed();
        }, duration.substr(0, duration.length - 1) * 1000);

        setTimeoutId(newTimeoutId);
        dispatch(removeOverlay(id));
      }
    }, [slideIn]);

    useEffect(() => {
      // Triggered every time "open" is changed, initially as well
      // Timeout to not trigger on the same frame as the render, to enable the slide-in

      setTimeout(() => setSlideIn(open), 1);

      if (open) {
        dispatch(addOverlay(id, close));
      }
    }, [open]);

    return open
      ? ReactDOM.createPortal(
          <div
            className={
              'side-menu' +
              (slideIn ? ' side-menu--open' : '') +
              (' from-' + from) +
              (className ? ' ' + className : '')
            }
            ref={ref}
            style={{ transitionDuration: duration }}
          >
            {headerRef && (
              <div className="side-menu__header">
                {showCloseButton &&
                  !disableClosing &&
                  (!closeButton ? (
                    <Icon
                      iconCode="close"
                      onClick={close}
                      iconClass="side-menu__close-icon"
                    />
                  ) : (
                    cloneElement(closeButton, {
                      onClick: close,
                    })
                  ))}
                {languageSwitcher?.props.currentChannel
                  ? languageSwitcher
                  : null}
                {headerRef}
              </div>
            )}
            {!headerRef &&
              showCloseButton &&
              !disableClosing &&
              (!closeButton ? (
                <Icon
                  iconCode="close"
                  onClick={close}
                  iconClass="side-menu__close-icon"
                />
              ) : (
                cloneElement(closeButton, {
                  onClick: close,
                })
              ))}
            {title && <h3 className="side-menu__title">{title}</h3>}
            {messageBar && (
              <div className="side-menu__message-bar">{messageBar}</div>
            )}
            <div className="side-menu__content">{children}</div>
            {footer && <div className="side-menu__footer">{footer}</div>}
          </div>,
          document.body
        )
      : null;
  }
);
